import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/admin/transport';
import TransportList from './Transport';


const ms2p = (state) => {
  return {
    ...state.transports,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(TransportList);
